import { connect } from "react-redux";
import { AnyAction, Dispatch } from "redux";
import { Creators as AllCreators } from "../../../actions";
import { IState } from "../../../App/reducer";
import { RequestState } from "../../../App/types/common";
import { CourseCompletionAnalytics } from "./CourseCompletionAnalytics.component";
import {
  ICourseCompletionAnalyticsDispatchProps,
  ICourseCompletionAnalyticsOwnProps,
  ICourseCompletionAnalyticsStateProps,
} from "./CourseCompletionAnalytics.types";

const Creators = (AllCreators as any).App.Dashboard;

const mapStateToProps = (state: IState): ICourseCompletionAnalyticsStateProps => ({
  analytics: state.App.Dashboard._.analytics,
  loading: ![RequestState.SUCCEEDED, RequestState.FAILED].includes(
    state.App.Dashboard._.fetchCourseCompletionAnalyticsState
  ),
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>, props: ICourseCompletionAnalyticsOwnProps) => ({
  loadAnalytics: () => {
    dispatch(Creators.fetchCourseCompletionAnalytics(props.isClass, props.courseId, props.objectId));
  },
});

export const CourseCompletionAnalyticsContainer = connect<
  ICourseCompletionAnalyticsStateProps,
  ICourseCompletionAnalyticsDispatchProps,
  ICourseCompletionAnalyticsOwnProps,
  IState
>(
  mapStateToProps,
  mapDispatchToProps
)(CourseCompletionAnalytics);
